// extracted by mini-css-extract-plugin
export default {"grid":"UserDashboardPage_grid__CTeMt","serviceBlock":"UserDashboardPage_serviceBlock__6OeUt","serviceList":"UserDashboardPage_serviceList__Zfepw"};